import { render } from "./OrderConfirm.vue?vue&type=template&id=cf58b316&scoped=true"
import script from "./OrderConfirm.vue?vue&type=script&lang=js"
export * from "./OrderConfirm.vue?vue&type=script&lang=js"

import "./OrderConfirm.vue?vue&type=style&index=0&id=cf58b316&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-cf58b316"

export default script